declare const __APP_TARGET__: 'embedded' | 'pi' | 'cloud';

export type AppTarget = 'embedded' | 'pi' | 'cloud';

export const APP_TARGET: AppTarget = __APP_TARGET__;

export type Capabilities = {
  firebaseSync: boolean;
  fleetView: boolean;
  remoteDiscovery: boolean;
};

const CAPABILITIES_BY_TARGET: Record<AppTarget, Capabilities> = {
  embedded: {
    firebaseSync: false,
    fleetView: false,
    remoteDiscovery: false,
  },
  pi: {
    firebaseSync: true,
    fleetView: false,
    remoteDiscovery: false,
  },
  cloud: {
    firebaseSync: true,
    fleetView: true,
    remoteDiscovery: true,
  },
};

export const capabilities: Capabilities = CAPABILITIES_BY_TARGET[APP_TARGET];
